"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 3,
  orderby: "count",
  order: "desc"
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
function TheTrendForecastConsumer() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-1 gap-4 md:grid-cols-12 md:grid-rows-[auto_auto] lg:gap-6">
        <div className="h-[500px] animate-pulse bg-muted md:col-span-5 md:row-span-2 md:h-full" />
        <div className="h-[400px] animate-pulse bg-muted md:col-span-7 lg:h-[500px]" />
        <div className="h-[250px] animate-pulse bg-muted md:col-span-7 lg:h-[300px]" />
      </div>;
  }
  if (error || terms.length === 0) {
    return null;
  }
  const fallbackImages = ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680334/img/surgical_kits_precision.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680334/img/ppe_safety_equipment.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680334/img/diagnostic_tools_clinical.png"];
  const gridClasses = ["md:col-span-5 md:row-span-2 h-[500px] md:h-auto min-h-[400px] md:min-h-[800px]", "md:col-span-7 h-[400px] lg:h-[500px]", "md:col-span-7 h-[300px] lg:h-[350px]"];
  return <div className="grid grid-cols-1 gap-4 md:grid-cols-12 md:grid-rows-[auto_auto] lg:gap-6">
      {terms.slice(0, 3).map((term, i) => <Link key={term.id} to="/RegistrationPage" data-index={i} className={`group relative block overflow-hidden border border-border bg-white ${gridClasses[i] || ""}`}>
          <img src={term.image_url || fallbackImages[i] || fallbackImages[0]} alt={`${term.name} category`} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" loading={i === 0 ? "eager" : "lazy"} />
          
          <div className="absolute inset-0 bg-white/40 backdrop-blur-[2px] transition-opacity duration-500 group-hover:opacity-0" />
          
          <div className="absolute top-4 right-4 font-mono text-xs text-muted-foreground">
            0{i + 1}
          </div>

          <div className="absolute bottom-6 left-6 md:bottom-8 md:left-8">
            <div className="inline-flex flex-col items-start gap-1 bg-white/90 px-6 py-4 text-foreground shadow-md backdrop-blur-md transition-all duration-300 group-hover:shadow-blue-500/20 group-hover:ring-1 group-hover:ring-ring">
              <h3 className="font-default text-sm font-bold uppercase tracking-widest md:text-base">
                {term.name}
              </h3>
              <span className="font-mono text-[10px] opacity-0 transition-opacity duration-300 group-hover:opacity-100 text-ring">
                REGISTER TO VIEW ITEMS
              </span>
            </div>
          </div>
        </Link>)}
    </div>;
}
export default function TheTrendForecast() {
  return <section data-section-id="222376" id="medical-supply-categories" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 flex flex-col items-start justify-between gap-6 md:mb-16 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <h2 className="font-default text-4xl font-bold uppercase tracking-tighter md:text-5xl lg:text-6xl">
              Supply Categories
            </h2>
            <p className="mt-4 font-default text-base text-muted-foreground md:text-lg">
              Precision-engineered medical consumables. Access our full inventory of surgical, diagnostic, and protective equipment through your verified LuminAid account.
            </p>
          </div>
          <Link to="/RegistrationPage" className="group inline-flex items-center gap-2 border-b border-primary pb-1 font-mono text-xs font-bold uppercase tracking-widest text-primary transition-colors hover:text-ring hover:border-ring">
            Sign up here
            <ArrowRight className="size-3 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>

        <EcommerceTermsProvider wp_term_query={wp_term_query}>
          <TheTrendForecastConsumer />
        </EcommerceTermsProvider>
      </div>
    </section>;
}